import { zodResolver } from "@hookform/resolvers/zod";
import { useForm, Controller } from "react-hook-form";
import { schema } from "./schema";
import { useContext } from "react";
import { ContextRegisterSupplier } from "../context";
import Notification from "../../../toast";
import reqFornecedor from "../../../../services/reqMultiTenant/reqFornecedor";

export const IndexHooks = () => {
	const { setSupplierData, setFilterData, openModalFilterSupplier, setLoading, currentPage, setPage, setTotalPage } =
		useContext(ContextRegisterSupplier);
	const {
		handleSubmit,
		register,
		watch,
		setFocus,
		formState: { errors, isSubmitting },
		control,
	} = useForm({
		mode: "onSubmit",
		resolver: zodResolver(schema),
		defaultValues: {
			param: '{"id": 1,"label":"Nome Fantasia","value":"nomefantasia"}',
			paramValue: "",
			active: true,
		},
	});

	const paramSelected = watch("param");

	const handleOnSubmit = async (data) => {
		const newData = {
			param: JSON.parse(data.param).value,
			paramValue: data.paramValue,
			active: data.active,
		};

		await fetchSupplier(newData);
	};

	const fetchSupplier = async (filterDataSelected) => {
		try {
			setLoading(true);
			const { param, paramValue, active } = filterDataSelected;

			let ativo = "NAO";
			if (active === true) ativo = "SIM";

			const responseSupplier = await reqFornecedor.listPaginate(param, paramValue, ativo, 1);
			const recordCount = responseSupplier.data.length;

			setSupplierData(responseSupplier.data);

			//se não encontrou nada esta na ultima pagina
			if (responseSupplier.data.length < 15) {
				setTotalPage(1);
			} else {
				setTotalPage(0);
				currentPage.current = 1;
			}

			const filter = { ...filterDataSelected, ativo, recordCount };

			setFilterData(filter);
			setPage(1);
			closeModal();
		} catch (error) {
			setSupplierData([]);
			Notification.showToast({ message: error.message, type: "warning" });
		} finally {
			setLoading(false);
		}
	};

	const closeModal = () => {
		openModalFilterSupplier((prevState) => !prevState);
	};

	return {
		errors,
		isSubmitting,
		register,
		handleSubmit,
		handleOnSubmit,
		paramSelected,
		setFocus,
		control,
		Controller,
	};
};
